import { v4 } from 'uuid'

export const UUIDs = {
  v4,
}
